import { apiClient } from '@/plugins/axios';


const getCatalogs = async () => {
  return apiClient.get('/catalogs?');
};

const updateCatalog = async (catalogData: any) => {
  return await apiClient.patch(`/catalogs/${catalogData.id}`, catalogData);
};

export default {
  getCatalogs,
  updateCatalog,
};
